import { createElement } from "./helper.js";

const template = createElement("div");
template.id = "spotlight";
template.innerHTML = (

    // the spinner needs to be a separated element to apply animation
    '<div class=spl-spinner></div>' +

    // the wrapper "spl-track" is required to forward pointer events
    '<div class=spl-track>' +
        '<div class=spl-scene>' +
            '<div class=spl-pane></div>' +
        '</div>' +
    '</div>' +
    '<div class=spl-header>' +
        '<div class=spl-gallery-title> </div>' +
        '<div class=spl-page> </div>' +
        // added via addControl()
        /*
        '<div class=spl-close></div>' +
        '<div class=spl-fullscreen></div>' +
        '<div class=spl-autofit></div>' +
        '<div class=spl-zoom-in></div>' +
        '<div class=spl-zoom-out></div>' +
        '<div class=spl-theme></div>' +
        '<div class=spl-play></div>' +
        '<div class=spl-download></div>' +
         */
    '</div>' +
    '<div class=spl-progress></div>' +
    '<button class=spl-prev></button>' +
    '<button class=spl-next></button>' +
    '<div class=spl-footer>' +
        '<div class=spl-caption>' +
            '<button class=spl-button>More</button>' +
            '<div class=spl-credit> </div>' +
            '<div class=spl-content>' +
                '<h2 class=spl-title> </h2>' +
                '<div class=spl-description> </div>' +
                '<a href="#" class="spl-button-more"></a>' +
            '</div>' +
        '</div>' +
        '<div class=spl-menu> </div>' +
    '</div>' 
);

export default template;
